<div class="card p-6 mb-6 text-center">
    <div class="font-semibold text-2xl mb-2">Paramètres de compte</div>
    <p class="text-gray-500">Gérez vos informations, notifications et sécurité</p>
</div>
<div class="card w-11/12 mx-auto p-2 md:p-6">
    <p-tabs [value]="value_tap()" (valueChange)="value_tap.set($event)" scrollable>
        <p-tablist>
            <p-tab value="0" class="flex items-center gap-2">
                <i class="pi pi-user text-xl"></i><span class="font-bold">Compte</span>
            </p-tab>

            <p-tab value="2" class="flex items-center gap-2">
                <i class="pi pi-fw pi-wallet text-xl"></i><span class="font-bold">Abonnement</span>
            </p-tab>
            <p-tab value="3" class="flex items-center gap-2">
                <i class="pi pi-envelope text-xl"></i><span class="font-bold">Contact</span>
            </p-tab>

        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="0">
                <app-user-profile></app-user-profile>
            </p-tabpanel>


            <p-tabpanel value="2">
                <app-subscriptions-profile></app-subscriptions-profile>
            </p-tabpanel>
            <p-tabpanel value="3">
                <div class="text-center text-gray-600 font-semibold text-lg md:text-xl lg:text-2xl mb-4 mt-2">
                    Contactez-nous
                </div>
                <p-button label="Contacter le support" icon="pi pi-envelope" class="cursor-pointer"
                    (click)="openEmailClient()"></p-button>

            </p-tabpanel>

        </p-tabpanels>
    </p-tabs>
</div>